// extracted by mini-css-extract-plugin
export default {"navigationClusterTitleLoader":"style_navigationClusterTitleLoader__+-mPJ"};